/**
 * Created by zhaoxinying
 */
import pointsEN from './points/en'
import pointsCN from './points/sc'
import pointsHK from './points/tc'
import myHomeEN from './myHome/en'
import myHomeCN from './myHome/sc'
import myHomeHK from './myHome/tc'
import identityEN from './identity/en'
import identityCN from './identity/sc'
import identityHK from './identity/tc'
import myCityEN from './myCity/en'
import myCityCN from './myCity/sc'
import myCityHK from './myCity/tc'
import applyIdEN from './applyId/en'
import applyIdCN from './applyId/sc'
import applyIdHK from './applyId/tc'
import boxEN from './box/en'
import boxCN from './box/sc'
import boxHK from './box/tc'
import antiEN from "./anti/en"
import antiCN from "./anti/sc"
import antiHK from "./anti/tc"
import metaIdCardEN from "./metaIdCard/en" 
import metaIdCardCN from "./metaIdCard/sc" 
import metaIdCardHK from "./metaIdCard/tc" 
import wolfTermsCN from './metaTerms/wolfTerm/sc'
import wolfTermsHK from './metaTerms/wolfTerm/tc'
import wolfTermsEN from './metaTerms/wolfTerm/en'
import resultPageCN from './resultPage/sc'
import resultPageHK from './resultPage/tc'
import resultPageEn from './resultPage/en'
export default {
  en: {
    points: pointsEN,
    myHome: myHomeEN,
    identity: identityEN,
    myCity: myCityEN,
    applyId: applyIdEN,
    box: boxEN,
    anti:antiEN,
    metaIdCard:metaIdCardEN,
    wolfTerms:wolfTermsEN,
    resultPage:resultPageEn,
  },
  sc: {
    points: pointsCN,
    myHome: myHomeCN,
    identity: identityCN,
    myCity: myCityCN,
    applyId: applyIdCN,
    box: boxCN,
    anti:antiCN,
    metaIdCard:metaIdCardCN,
    wolfTerms:wolfTermsCN,
    resultPage:resultPageCN,
  },
  tc: {
    points: pointsHK,
    myHome: myHomeHK,
    identity: identityHK,
    myCity: myCityHK,
    applyId: applyIdHK,
    box: boxHK,
    anti:antiHK,
    metaIdCard:metaIdCardHK,
    wolfTerms:wolfTermsHK,
    resultPage:resultPageHK,
  }
}
